export {
  savedQueriesPlugin,
  type SavedQuery,
  type SavedQueriesPluginProps,
} from "./saved-queries-plugin";
